<script>
import InputText from '@components/form/InputText'
// import InputCheckbox from '@components/form/InputCheckbox'
// import InputAutocomplete from '@components/form/InputAutocompleteUsers'
//   import { mapGetters } from 'vuex'

export default {
  name: 'ExpertForm',

  components: {
    'input-text': InputText,
    // 'input-checkbox': InputCheckbox,
    // autocomplete: InputAutocomplete,
  },

  props: {
    form: {
      type: Object,
      required: true,
    },

    tryingToLogIn: {
      type: Boolean,
      default: false,
    },

    tryToRegister: {
      type: Function,
      required: true,
    },
  },

  // data() {
  //   return {
  //   }
  // },
}
</script>

<template>
  <b-card class="m-0 p-0">
    <b-form>
      <ValidationObserver v-slot="{ handleSubmit }">
        <input-text
          name="first_name"
          label="Nombres"
          validate="required"
          :value.sync="form.user.first_name"
        />

        <input-text
          name="last_name"
          label="Apellidos"
          validate="required"
          :value.sync="form.user.last_name"
        />

        <input-text
          name="institute"
          label="Municipio"
          validate="required"
          :value.sync="form.institute"
        />

        <input-text
          name="position"
          label="Sector"
          validate="required"
          :value.sync="form.position"
        />

        <div class="pt-2">
          <b-button
            block
            variant="primary"
            :disabled="tryingToLogIn"
            @click=";[handleSubmit(tryToRegister)]"
          >
            <div v-if="tryingToLogIn">
              <b-spinner small class="mx-2"></b-spinner>
            </div>
            <div v-else>
              Continuar
            </div>
          </b-button>
        </div>
      </ValidationObserver>
    </b-form>
  </b-card>
</template>

<style lang="scss" scoped></style>
